import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { isMobile } from '../../../helpers';

import logoWhite from "../../../assets/img/logo/araciste-logo.png"

class Header extends Component {
  constructor(props) {
    super(props);

    this.state = {
      path: this.props.path
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      path: nextProps.path.toLowerCase()
    })
  }
  render() {
    return (
      <a href="/auth/sign-in" className="link-go-to-back">
        <div className="header"
        >
          <img alt="Logo" className="logo" src={logoWhite} />
          <NavLink to="/auth/sign-in" className="link-go-to-back">
            <img alt="back-logo" className={(this.state.path === 'forgot-password' && isMobile()) ? "back-logo-mobile" : 'invisible-logo'} src="/assets/img/icons/icon-back.png" />
          </NavLink>
        </div>
      </a>
    )
  }
}

const mapStateToProps = ({ auth }) => ({ ...auth });
export default connect(mapStateToProps)(Header);





// WEBPACK FOOTER //
// ./src/components/Auth/Layout/Header.js